import PropTypes from 'prop-types';
import React from 'react';
import { Box, IconButton } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import StyledTypography from '../../StyledTypography/StyledTypography';
import { PRIMARY_SOFTER } from './styles';

const rowSx = {
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: 1,
};

/**
 * Bloque "Saldo disponible": título + botón actualizar, y filas Bienes /
 * Propiedades con etiquetas cortas (no se parten con montos grandes).
 */
function BalanceBox({ balance, propertyBalance, onRefresh, formatCLP }) {
  return (
    <Box sx={{ backgroundColor: PRIMARY_SOFTER, borderRadius: 2, px: 1.5, py: 1, mb: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <StyledTypography size="15px" weight={700} customColor="#5D6871" display="inline">
          Saldo disponible
        </StyledTypography>
        <IconButton style={{ padding: '2px' }} color="primary" onClick={onRefresh} size="small">
          <SyncIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={rowSx}>
        <StyledTypography size="15px" weight={300} customColor="#5D6871" display="inline">
          Bienes
        </StyledTypography>
        <StyledTypography size="17px" color="primary" weight={600} display="inline" textAlign="right">
          {formatCLP(balance)}
        </StyledTypography>
      </Box>

      <Box sx={rowSx}>
        <StyledTypography size="15px" weight={300} customColor="#5D6871" display="inline">
          Propiedades
        </StyledTypography>
        <StyledTypography size="17px" color="primary" weight={600} display="inline" textAlign="right">
          {formatCLP(propertyBalance)}
        </StyledTypography>
      </Box>
    </Box>
  );
}

BalanceBox.propTypes = {
  balance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  propertyBalance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onRefresh: PropTypes.func,
  formatCLP: PropTypes.func.isRequired,
};

export default BalanceBox;
